import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MxMaterialModule} from '../material/mx-material.module';
import {MxInfoDirective} from './directives/mx-info/mx-info.directive';
import {RestrictDirective} from './directives/restrict/restrict.directive';
import {FilterArrayByItemPropertyPipe} from './pipes/filter-array-by-item-property.pipe';
import {FilterPipe} from './pipes/filter.pipe';
import {MxSafeHtmlPipe} from './pipes/mx-safe-html.pipe';
import {SecureImgPipe} from './pipes/secure-img.pipe';
import {SecureTextPipe} from './pipes/secure-text.pipe';
import {ZoneDatePipe} from './pipes/zoneDate.pipe';
import {MxTranslatePipe} from './pipes/mx-translate.pipe';

@NgModule({
    imports: [
        CommonModule,
        MxMaterialModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    // Reusable components should be declared here
    declarations: [
        FilterPipe,
        FilterArrayByItemPropertyPipe,
        RestrictDirective,
        MxInfoDirective,
        MxTranslatePipe,
        MxSafeHtmlPipe,
        SecureImgPipe,
        SecureTextPipe,
        ZoneDatePipe
    ],
    exports: [
        CommonModule,
        FilterArrayByItemPropertyPipe,
        FilterPipe,
        FormsModule,
        MxInfoDirective,
        MxMaterialModule,
        MxTranslatePipe,
        MxSafeHtmlPipe,
        ReactiveFormsModule,
        RestrictDirective,
        SecureImgPipe,
        SecureTextPipe,
        ZoneDatePipe
    ]
})
export class MxSharedModule {
}
